export default __webpack_public_path__ + "static/media/bill.4a71ab96.png";